import React, { Suspense } from "react";
import Config from "app_config";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "evergreen-ui";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import SimpleReactLightbox from "simple-react-lightbox";
import configureStore from "./store";
import mixpanel from "mixpanel-browser";
import * as serviceWorker from "./serviceWorker";
import ContentDashTheme from "./apps/main/Layouts/theme";
import DarkContentDashTheme from "./apps/main/Layouts/dark-theme";
import ActionCable from "actioncable";
import { ActionCableProvider } from 'react-actioncable-provider';
import './index.less';
import { isDesktop } from 'react-device-detect';

if (Config.REACT_APP_ENV === "production") {
  mixpanel.init(Config.REACT_APP_MIXPANEL_KEY);
}

const paypalInitialOptions = {
  "client-id": Config.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "PHP",
};

const cable = ActionCable.createConsumer(Config.REACT_APP_WS_ROOT)

if (Config.REACT_APP_NAME === "main") {
  const AppRouter = React.lazy(() => import("routers/AppRouter"));
  const appStore = configureStore();
  const appJsx = (
    <Provider store={appStore}>
        {/* <ErrorBoundary> */}
        <ActionCableProvider cable={cable}>
        <DndProvider backend={HTML5Backend}>
          <PayPalScriptProvider options={paypalInitialOptions}>
            <ThemeProvider value={isDesktop ? ContentDashTheme : DarkContentDashTheme}>
              <SimpleReactLightbox>
                <Suspense fallback={<div/>} >
                  <AppRouter/>
                </Suspense>
              </SimpleReactLightbox>
            </ThemeProvider>
          </PayPalScriptProvider>
        </DndProvider>
        </ActionCableProvider>
        {/* </ErrorBoundary> */}
    </Provider>
  );
  ReactDOM.render(appJsx, document.getElementById("root"));

} else if (Config.REACT_APP_NAME === "dow"){
  const DowRouter = React.lazy(() => import("routers/DowRouter"));
  const appStore = configureStore();
  const appJsx = (
    <Provider store={appStore}>
        {/* <ErrorBoundary> */}
        <ActionCableProvider cable={cable}>
        <ThemeProvider value={ContentDashTheme}>
          <SimpleReactLightbox>
            <Suspense fallback={<div/>} >
              <DowRouter />
            </Suspense>
          </SimpleReactLightbox>
        </ThemeProvider>
        </ActionCableProvider>
        {/* </ErrorBoundary> */}
    </Provider>
  );
  ReactDOM.render(appJsx, document.getElementById("root"));

} else if (Config.REACT_APP_NAME === "doc"){
  const DocRouter = React.lazy(() => import("routers/DocRouter"));
  const appStore = configureStore();
  const appJsx = (
    <Provider store={appStore}>
        {/* <ErrorBoundary> */}
        <ActionCableProvider cable={cable}>
        <DndProvider backend={HTML5Backend}>
          <ThemeProvider value={ContentDashTheme}>
            <SimpleReactLightbox>
              <Suspense fallback={<div/>} >
                <DocRouter />
              </Suspense>
            </SimpleReactLightbox>
          </ThemeProvider>
        </DndProvider>
        </ActionCableProvider>
        {/* </ErrorBoundary> */}
    </Provider>
  );
  ReactDOM.render(appJsx, document.getElementById("root"));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
